import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

const KVKKModal = ({ visible, onHide, onApprove }) => {

    return (
        <Dialog
            visible={visible}
            onHide={onHide}
            header="Kişisel Verilerin Korunması Kanunu (KVKK) Aydınlatma Metni"
            style={{ width: '95vw', maxWidth: '800px', height: '95vh' }}
            className="kvkk-modal"
            modal
            closable={true}
            resizable={false}
        >
            <div
                className="kvkk-content"
                style={{
                    height: 'calc(95vh - 200px)',
                    maxHeight: 'calc(95vh - 200px)',
                    overflowY: 'auto',
                    padding: '1rem 0',
                    marginBottom: '1rem'
                }}
            >
                <div className="prose prose-sm">
                    {/* İçerik aynı kalıyor - sadece son div'e mb-6 ekleniyor */}
                    <h2 className="font-bold text-lg mb-4">KİŞİSEL VERİLERİN KORUNMASI KANUNU AYDINLATMA METNİ</h2>

                    <p className="mb-4">
                        6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") uyarınca, PayPlus olarak, Veri Sorumlusu sıfatıyla,
                        siz değerli müşterilerimizin kişisel verilerini aşağıda açıklanan amaçlar kapsamında hukuka ve dürüstlük
                        kurallarına uygun bir şekilde işleyebilecek, kaydedebilecek, saklayabilecek, sınıflandırabilecek,
                        güncelleyebilecek ve mevzuatın izin verdiği hallerde ve/veya işlendikleri amaçla sınırlı olarak 3. kişilere
                        açıklayabilecek/aktarabilecektir.
                    </p>

                    <h3 className="font-bold text-md mb-3">1. KİŞİSEL VERİLERİN İŞLENME AMACI</h3>
                    <p className="mb-3">Kişisel verileriniz;</p>
                    <ul className="list-disc pl-5 mb-4 space-y-1">
                        <li>Hizmetlerimizden faydalanabilmeniz için gerekli çalışmaların ilgili birimlerce yapılabilmesi,</li>
                        <li>Size özel kampanya, avantaj ve hizmetlerin sunulması,</li>
                        <li>Aldığınız/alacağınız ürün ve hizmete ilişkin iletişim kurulabilmesi,</li>
                        <li>Ödeme işlemlerinizin gerçekleştirilmesi,</li>
                        <li>İç işleyişin sağlanması ve geliştirilmesi,</li>
                        <li>Hukuki süreçlerin yürütülmesi,</li>
                        <li>Mevzuattan kaynaklanan yükümlülüklerimizin yerine getirilmesi,</li>
                        <li>Müşteri memnuniyeti çalışmalarının yürütülmesi,</li>
                        <li>Risk yönetimi ve denetim faaliyetlerinin gerçekleştirilmesi,</li>
                    </ul>
                    <p className="mb-4">
                        amaçlarıyla KVKK'nın 5. ve 6. maddelerinde belirtilen kişisel veri işleme şartları ve amaçları dahilinde işlenecektir.
                    </p>

                    <h3 className="font-bold text-md mb-3">2. KİŞİSEL VERİLERİN AKTARILMASI</h3>
                    <p className="mb-4">
                        Kişisel verileriniz; yukarıda belirtilen amaçlar doğrultusunda, KVKK'nın 8. ve 9. maddelerinde belirtilen
                        şartlara uygun olarak, PayPlus tarafından hizmetin gerçekleştirilmesi için iş ortaklarımıza, tedarikçilerimize,
                        kanunen yetkili kamu kurumlarına, bankalar ve finansal kuruluşlar, bilişim teknolojileri hizmet sağlayıcıları
                        ve özel kişilere aktarılabilecektir.
                    </p>

                    <h3 className="font-bold text-md mb-3">3. KİŞİSEL VERİ TOPLAMANIN YÖNTEMİ VE HUKUKİ SEBEBİ</h3>
                    <p className="mb-4">
                        Kişisel verileriniz, her türlü sözlü, yazılı ya da elektronik ortamda, web sitesi, mobil uygulama,
                        çağrı merkezi, şubeler ve benzeri kanallar aracılığıyla yukarıda yer verilen amaçlar doğrultusunda
                        hizmetlerimizin sunulabilmesi ve bu kapsamda PayPlus'ın sözleşme ve yasadan doğan mesuliyetlerini
                        eksiksiz ve doğru bir şekilde yerine getirebilmesi için toplanır.
                    </p>

                    <h3 className="font-bold text-md mb-3">4. KİŞİSEL VERİLERİN SAKLANMA SÜRESİ</h3>
                    <p className="mb-4">
                        Kişisel verileriniz, işlendikleri amaçla bağlantılı olarak mevzuatta öngörülen süreler boyunca ve/veya
                        işlendikleri amaç için gerekli olan süre boyunca saklanacaktır. Bu sürelerin belirlenmesinde, ilgili mevzuattan
                        kaynaklanan yükümlülükler gözetilmektedir.
                    </p>

                    <h3 className="font-bold text-md mb-3">5. KİŞİSEL VERİ SAHİBİNİN HAKLARI</h3>
                    <p className="mb-3">KVKK'nın 11. maddesi uyarınca herkes, veri sorumlusuna başvurarak kendisiyle ilgili;</p>
                    <ul className="list-disc pl-5 mb-4 space-y-1">
                        <li>Kişisel veri işlenip işlenmediğini öğrenme,</li>
                        <li>Kişisel verileri işlenmişse buna ilişkin bilgi talep etme,</li>
                        <li>Kişisel verilerin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme,</li>
                        <li>Yurt içinde veya yurt dışında kişisel verilerin aktarıldığı üçüncü kişileri bilme,</li>
                        <li>Kişisel verilerin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme,</li>
                        <li>Kişisel verilerin silinmesini veya yok edilmesini isteme,</li>
                        <li>Kişisel verilerin düzeltilmesi, silinmesi ya da yok edilmesi halinde bu işlemlerin kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme,</li>
                        <li>İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle kişinin kendisi aleyhine bir sonucun ortaya çıkmasına itiraz etme,</li>
                        <li>Kişisel verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara uğraması hâlinde zararın giderilmesini talep etme haklarına sahiptir.</li>
                    </ul>

                    <h3 className="font-bold text-md mb-3">6. BAŞVURU YÖNTEMLERİ</h3>
                    <p className="mb-4">
                        Yukarıda belirtilen haklarınızı kullanmak için PayPlus'a yazılı olarak başvurabilirsiniz.
                        Başvurularınızı info@payplus.com.tr e-posta adresine veya PayPlus Genel Müdürlük adresine
                        posta yoluyla iletebilirsiniz.
                    </p>

                    <div className="bg-blue-50 p-4 rounded-lg mt-6">
                        <p className="text-sm text-blue-800">
                            <strong>Not:</strong> Bu aydınlatma metni, 6698 sayılı Kişisel Verilerin Korunması Kanunu ve
                            ilgili mevzuat çerçevesinde hazırlanmıştır. PayPlus, yasal düzenlemelerdeki değişikliklere bağlı
                            olarak bu metni güncelleme hakkını saklı tutar.
                        </p>
                    </div>
                </div>
            </div>

            <div
                className="flex justify-end gap-3 mt-4 pt-4 border-t bg-white sticky bottom-0"
                style={{
                    position: 'sticky',
                    bottom: 0,
                    backgroundColor: 'white',
                    borderTop: '1px solid #e5e7eb',
                    paddingTop: '1rem',
                    marginTop: '1rem'
                }}
            >
                <Button
                    label="İptal"
                    className="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-lg text-sm"
                    onClick={onHide}
                />
                <Button
                    label="Okudum ve Onaylıyorum"
                    className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg text-sm"
                    onClick={() => {
                        onApprove();
                        onHide();
                    }}
                />
            </div>
        </Dialog>
    );
};

export default KVKKModal;